import {
    ChangeEvent,
    FC,
    FormEvent,
    useState,
} from 'react'
import Select from 'react-select'
import {
    Button,
    Col,
    CustomInput,
    FormGroup,
    Label,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from 'reactstrap'

import FormDatePicker from '../../../../components/FormDatePicker/FormDatePicker'
import Icon from '../../../../components/style/Icon/Icon'
import { getObjProperty } from '../../../../helpers'
import { formatDate } from '../../../../helpers/date'
import { translate } from '../../../../helpers/translations/translator'
import { SpecialDay, SpecialDayFormData, SpecialDayType } from '../../../entities/SpecialDay/SpecialDay'

export interface EditSpecialDayProps {
    onSubmit: (data: SpecialDayFormData) => void;
    onCancel: () => void;
    specialDay: SpecialDay;
    specialDayTypes: SpecialDayType[];
}

const EditSpecialDayForm: FC<EditSpecialDayProps> = ({
    onSubmit,
    onCancel,
    specialDay,
    specialDayTypes,
}) => {
    const [specialDayType, setspecialDayType] = useState(getObjProperty(specialDay, 'type'))
    const [date, setDate] = useState(getObjProperty(specialDay, 'date') || new Date())
    const [description, setDescription] = useState(getObjProperty(specialDay, 'description') || '')
    const [isVisibleInEmployeeApp, setIsVisibleInEmployeeApp] = useState(getObjProperty(specialDay, 'isVisibleInEmployeeApp') || false)

    const canSubmit = !! description.length && specialDayType

    const submitSpecialDay = (event: FormEvent) => {
        event.preventDefault()

        onSubmit({
            id: getObjProperty(specialDay, 'id'),
            date: formatDate(date, 'yyyy-MM-dd'),
            type: specialDayType || specialDayTypes[0].name,
            isVisibleInEmployeeApp,
            description,
        })
    }

    const options = specialDayTypes.map((val) => (
        {
            label: <Icon kind={val.name} />,
            value: val.name,
            id: val.name,
        }
    ))

    return (
        <form onSubmit={(event) => submitSpecialDay(event)}>
            <ModalHeader>{`${translate('pages.specialDays.specialDay')} ${translate('common.edit')}`}</ModalHeader>
            <ModalBody>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{translate('common.category')}</Label>
                            <Select
                                classNamePrefix="react-select"
                                value={options.find(option => option.id === specialDayType)}
                                placeholder={translate('pages.specialDays.selectIcon')}
                                id="type"
                                options={options}
                                onChange={(value) => setspecialDayType(value?.id || specialDayTypes[0].id)}
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>{translate('common.date')}</Label>
                            <FormDatePicker
                                selected={date}
                                onChange={(value: Date) => setDate(value)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{translate('common.description')}</Label>
                            <CustomInput
                                className="form-control"
                                type="text"
                                id="description"
                                name="description"
                                value={description}
                                onChange={(event: ChangeEvent<HTMLInputElement>) => setDescription(event.target.value)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <FormGroup check>
                        <Label check>
                            <CustomInput
                                checked={isVisibleInEmployeeApp}
                                label={translate('pages.specialDays.isVisibleInEmployeeApp')}
                                type="checkbox"
                                id="isVisibleInEmployeeApp"
                                onChange={() => setIsVisibleInEmployeeApp(! isVisibleInEmployeeApp)}
                            />
                        </Label>
                    </FormGroup>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button type="button" color="link" id="modal-close" onClick={onCancel}>{translate('common.cancel')}</Button>
                <Button type="submit" color="orange" disabled={! canSubmit}>{translate('common.edit')}</Button>
            </ModalFooter>
        </form>
    )
}

export default EditSpecialDayForm
